import './creativecuisine/style';
import FormStructure from './creativecuisine/form_structure';

export default FormStructure;